import { styled } from 'styled-components';

interface RootProps {
    columns?: string;
    rows?: string;
    gap?: number | string;
}

export const Root = styled.div<RootProps>`
    flex: 1 1;
    display: grid;
    grid-template-columns: ${(props) => props.columns ?? 'repeat(6, minmax(0, 1fr))'};
    grid-template-rows: ${(props) => props.rows ?? 'auto'};
    gap: ${({ gap, theme }) =>
        typeof gap === 'number' ? `${gap}px` : gap ? gap : `${theme.spacing(5)}`};

    & > * {
        min-width: 0;
    }

    @media only screen and (max-width: 1280px) {
        grid-template-columns: ${(props) =>
            props.columns ? props.columns : 'repeat(5, minmax(0, 1fr))'};
    }
    @media only screen and (max-width: 1024px) {
        grid-template-columns: ${(props) =>
            props.columns ? props.columns : 'repeat(4, minmax(0, 1fr))'};
    }
    @media only screen and (max-width: 768px) {
        grid-template-columns: ${(props) =>
            props.columns ? props.columns : 'repeat(3, minmax(0, 1fr))'};
    }
    @media only screen and (max-width: 480px) {
        grid-template-columns: ${(props) =>
            props.columns ? props.columns : 'repeat(2, minmax(0, 1fr))'};
    }
    @media only screen and (max-width: 320px) {
        grid-template-columns: ${(props) => (props.columns ? props.columns : '1fr')};
    }
`;
